import { render, staticRenderFns } from "./NoteSection.vue?vue&type=template&id=e03d513a"
import script from "./NoteSection.vue?vue&type=script&lang=js"
export * from "./NoteSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports